/**
 * ConiferStand.js
 *
 * The five conifers at the lower right of the landing sky.
 *
 * WHY THESE ARE NOT IN MountainRange
 * ----------------------------------
 * The mountain ranges are authored for a 1280-wide stage and are allowed to
 * stretch horizontally (`preserveAspectRatio="none"`), which is fine for a
 * ridgeline — a hill is still a hill 20% wider. It is not fine for a tree: the
 * same stretch turned the conifers into fat shrubs on a wide window. So the
 * trees moved into their own SVG, which keeps its aspect ratio and anchors to
 * the bottom-right corner instead of scaling with the stage.
 *
 * COORDINATE SPACE
 * ----------------
 * The trees are drawn in the same 230-unit vertical space as MountainRange, in a
 * viewBox 180 units wide. Two things follow, both relied on elsewhere:
 *
 *   - The tree bases sit 44 units above the bottom edge, so they stay planted in
 *     the meadow — which MountainRange draws in that same 230-unit space, scaled
 *     by the same height, so the two agree by construction rather than by
 *     coincidence.
 *   - The rightmost tree's right edge is at x = 145.24 (translate 136 plus the
 *     path's local max x of 21, scaled 0.44), leaving 34.76 units of EMPTY box to
 *     its right. LandingSky.css subtracts exactly that padding when it positions
 *     the stand, so the tree — not the box — lands on the page's right margin.
 *     Move a tree and that number must be re-derived there.
 *
 * WHERE THE STAND SITS is entirely LandingSky.css's business: it is pinned to the
 * right margin (the edge the Login button and the copyright end on), not to the
 * window's corner. The translates below are internal layout and say nothing about
 * screen position. Note that the reference file expresses the same move by shifting
 * these translates left instead; here they are left alone so the stand can follow
 * the margin token at every width and height.
 *
 * The CSS sets width and height in the viewBox's own 180:230 ratio, so the
 * default `preserveAspectRatio` has no slack to take up and the trees cannot
 * distort. See `.landing-sky-conifers` in LandingSky.css.
 *
 * Purely decorative — hence aria-hidden.
 */

import React from 'react';

const ConiferStand = () => (
  <svg
    className="landing-sky-conifers"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 180 230"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      {/* Suffixed id: inline SVGs share one global id space with every other
          inline SVG on the page, so this must not collide with MountainRange's. */}
      <path
        id="landingSkyConifer"
        d="M0 -100 L8 -80 L4 -80 L13 -58 L8 -58 L17 -34 L11 -34 L21 -8 L2 -8 L2 0 L-2 0 L-2 -8 L-21 -8 L-11 -34 L-17 -34 L-8 -58 L-13 -58 L-4 -80 L-8 -80 Z"
      />
    </defs>

    {/* Scales and fills verbatim from the reference. Translates are this viewBox's
        own coordinates; the stand's position on the page is set in CSS. */}
    <use href="#landingSkyConifer" transform="translate(8 184) scale(0.36)" fill="#050B0F" />
    <use href="#landingSkyConifer" transform="translate(50 183) scale(0.56)" fill="#050B0F" />
    <use href="#landingSkyConifer" transform="translate(80 185) scale(0.86)" fill="#040A0D" />
    <use href="#landingSkyConifer" transform="translate(108 184) scale(0.64)" fill="#050B0F" />
    <use href="#landingSkyConifer" transform="translate(136 186) scale(0.44)" fill="#050B0F" />
  </svg>
);

export default ConiferStand;
